import React from 'react';
import PropTypes from 'prop-types';
import { StatoOperazione, PENDING_OPERATION, COMPLETED_OPERATION } from './SnackbarUtils';
import Spinner from '../Spinner';
import SuccessoIcon from '../Icons/SuccessoIcon';
import ErroreIcon from '../Icons/ErroreIcon';

const anyAsycRunning = operazioniMassive => operazioniMassive.filter(
  x => x.stato === StatoOperazione.PENDING,
).length > 0;

const getMessage = (operazioniMassive) => {
  if (anyAsycRunning(operazioniMassive)) {
    return PENDING_OPERATION;
  }
  return COMPLETED_OPERATION;
};

const getIcon = (operazioniMassive) => {
  if (anyAsycRunning(operazioniMassive)) return <Spinner small />;
  const ultimaOperazione = operazioniMassive
    .filter(x => x.finishedTimestamp)
    .sort((a, b) => new Date(a.timeStamp) - new Date(b.timeStamp))[0];
  if (ultimaOperazione) {
    if (ultimaOperazione.errori.length > 0) {
      return <ErroreIcon className="icon snackbar__iconWarning" />;
    }
    return <SuccessoIcon className="icon snackbar__iconSuccess" />;
  }
  return null;
};

const HeaderMassiva = ({ operazioniMassive }) => (
  <div className="snackbar__titoloHeader">
    <div className="snackbar__iconWrapper">
      {getIcon(operazioniMassive)}
    </div>
    <p className="snackbar__title">
      {getMessage(operazioniMassive)}
    </p>
  </div>
);

HeaderMassiva.propTypes = {
  operazioniMassive: PropTypes.arrayOf(PropTypes.shape({
    stato: PropTypes.number,
    finishedTimestamp: PropTypes.any,
  })),
};

HeaderMassiva.defaultProps = {
  operazioniMassive: [],
};

export default HeaderMassiva;
